<template>
  <div class="slide-container">
    <div class="title" v-if="isShowTitle">
      <span>{{dataTitle}}</span>
      <span  v-show="hasMore===1" class="more" @click="toMore">更多<img src="@/assets/icon_jump.png"></span>
    </div>
    <div class="slide-line" ref="scroll">
      <!-- 单排可滑动列表 -->
      <div v-for="(item, key) in list" :key="key" @click="clickOpen(item)" class="item-container">
        <div class="item">
          <div class="header">
            <img :src="item.icon">
            <div class="playback">
              <img src="@/assets/icon_book.png">
              <span>{{ randomNumber() }}人正在学习</span>
            </div>
          </div>
          <!-- <div class="title">{{ item.title }}</div> -->
          <div class="comm">{{ item.comment | commentFilter}}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { cblockItem } from '@/api/app'
import { substring } from '@/utils/index'

export default {
  name: 'NotslideRow',
  props: {
    isShowTitle: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Number,
      default: 1
    },
    dataId: {
      default: null
    },
    dataTitle: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: () =>{
        return []
      }
    }
  },
  data () {
    return {
      startLeft: 0,
      startTopAbsolute: 0
    }
  },
  filters: {
    commentFilter(comment) {
      return substring(comment, 16, true)
    }
  },
  mounted() {
    this.addListener()
  },
  methods: {
    toMore: function(){
      this.$emit('clickMore', this.dataId, this.dataTitle);
    },
    clickOpen: function(item){
      cblockItem(item, this)
    },
    randomNumber(){
      return parseInt(Math.random()*4900)+100
    },
    handleTouchStart(e) {
      const touch = e.touches[0];
      this.startLeft = touch.pageX;
      this.startTopAbsolute = touch.clientY;
    },
    handleTouchMove(e) {
      const touch = e.touches[0];
      const currentLeft = touch.pageX;
      const currentTopAbsolute = touch.clientY;
      var offsetLeft = currentLeft - this.startLeft;
      var offsetTop = currentTopAbsolute - this.startTopAbsolute;
      var distanceX = Math.abs(offsetLeft);
      var distanceY = Math.abs(offsetTop);
      if (distanceX < 5 || (distanceX >= 5 && distanceY >= 1.73 * distanceX)) {
        // 纵向滑动 判定
        return;
      }
      e.stopPropagation()
    },
    handleScroll() {
      const elem = this.$refs.scroll
      this.scrollPer = elem.scrollWidth == 0?0:elem.scrollLeft/(elem.scrollWidth-elem.clientWidth)
    },
    addListener() {
      this.$refs.scroll.addEventListener('touchstart', this.handleTouchStart);
      this.$refs.scroll.addEventListener('touchmove', this.handleTouchMove);
      this.$refs.scroll.addEventListener('scroll', this.handleScroll)
    },
    removeListener() {
      const elem = this.$refs.scroll;
      elem.removeEventListener('touchstart', this.handleTouchStart);
      elem.removeEventListener('touchmove', this.handleTouchMove);
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy() {
    this.removeListener()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slide-container{
  padding: 8px 16px;
  color: #333;
}
.slide-container .title{
    display: flex;
    justify-content:space-between;
    font-size: 16px;
    font-weight:bold;
    padding: 12px 0;
}
.slide-container .title .more{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 100;
    color: #AAA;
}
.slide-container .title img{
    width: 16px;
}
.slide-line::-webkit-scrollbar {
  display: none;
  width: 0 !important;
}
.slide-line {
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  display: flex;
  overflow-y: hidden;
  overflow-x: scroll;
  justify-content:space-between;
  -webkit-overflow-scrolling: touch;
}
.slide-line .item {
  border: 4px;

  color: #444;
  text-align: left;
  flex-grow: 0;
  margin-right: 8px;
}
.slide-line .item-container:last-child .item{
    margin-right: 0;
}
.slide-line .item .header{
    position: relative;
}
.slide-line .item .header > img{
    width: 136px;
    height: 136px;
    border-radius: 12px;
    display: block;
}
.slide-line .item .header .playback{
    width: 100%;
    text-align: left;
    background-color: rgba(0,0,0,0.15);
    position: absolute;
    bottom: 0;
    padding: 5px 0;
    color: #fff;
    font-size: 10px;
    display: flex;
    align-items: center;
    border-radius: 0 0 12px 12px;
}
.slide-line .item .header .playback img{
  width: 14px;
  margin: 0 5px;
}
/* .slide-line .item .title,
.slide-line .item .comm{
    padding: 0.5rem;
}
.slide-line .item .title{
    font-size: 0.875rem;
    font-weight:bold;
} */
.slide-line .item .comm{
  font-size: 14px;
  font-weight: 600;
  margin-top: 4px;
}
</style>
